import { useLocation, Outlet } from "react-router-dom";
import { AppShellContext } from "./AppShellContext";
import TopHeader from "./TopHeader";
import BottomNavigation from "./BottomNavigation";
import NavigationRail from "./NavigationRail";
import PlatformOfflineStrip from "./PlatformOfflineStrip";
import { isArenaSessionPath } from "./isArenaSessionPath";
import styles from "./shell.module.css";
import { cn } from "../utils/cn";

/**
 * Responsive platform application shell (UX Wave 1).
 * Arena live session (`/room/:code/session`) hides global chrome — session shell owns header + bottom nav.
 */
export default function AppShell({
  children,
  className,
  showBottomNav = true,
  showRail = true,
  hideDesktopNav = false,
}) {
  const { pathname } = useLocation();
  const arenaSession = isArenaSessionPath(pathname);
  const content = children ?? <Outlet />;
  const bottomNav = showBottomNav && !arenaSession;
  const rail = showRail && !arenaSession;

  return (
    <AppShellContext.Provider value={{ embedded: true, arenaSession }}>
      <div
        className={cn(styles.shell, arenaSession && styles.shellArenaSession, className)}
        data-testid="platform-app-shell"
        data-arena-session={arenaSession ? "true" : undefined}
        data-tra-weight-policy={arenaSession ? undefined : "platform"}
      >
        {arenaSession ? null : <TopHeader hideDesktopNav={hideDesktopNav} />}
        {arenaSession ? null : <PlatformOfflineStrip />}
        <div
          className={cn(
            styles.shellMain,
            rail && styles.shellMainWithRail,
            !bottomNav && styles.shellMainDesktop,
            arenaSession && styles.shellMainArenaSession
          )}
        >
          {rail ? <NavigationRail /> : null}
          <div className={styles.shellContent}>{content}</div>
        </div>
        {bottomNav ? <BottomNavigation /> : null}
      </div>
    </AppShellContext.Provider>
  );
}
